import api from './api';

export interface AprilscherzStatus {
  aktiv: boolean;
  heute_erster_april: boolean;
  anzeigen: boolean;
  jahr: number;
}

export const aprilscherzService = {
  getStatus: async (options?: { quiet?: boolean }): Promise<AprilscherzStatus> => {
    const response = await api.get<AprilscherzStatus>(
      '/aprilscherz',
      options?.quiet ? { skipErrorNotify: true } : undefined,
    );
    return response.data;
  },
  update: async (aktiv: boolean): Promise<AprilscherzStatus> => {
    const response = await api.put<AprilscherzStatus>('/aprilscherz', { aktiv });
    return response.data;
  },
};
